import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  if (import.meta.env.DEV) console.warn('Supabase credentials not configured')
}

export const supabase = createClient(
  supabaseUrl || '',
  supabaseAnonKey || '',
  {
    auth: {
      // Persist session in localStorage to survive page reloads
      persistSession: true,
      // Automatically refresh tokens before they expire
      autoRefreshToken: true,
      // Detect session from URL (for magic link redirects)
      detectSessionInUrl: true,
      // Storage key for session
      storageKey: 'ghina-auth-session'
    }
  }
)
